import {INutritionFieldsFragment} from "app/gql/graphqlSchema";

interface IProps {
  nutrition: INutritionFieldsFragment;
  className?: string;
}
export const NutritionSummary = ({nutrition, className}: IProps) => {
  return (
    <span className={className}>
      {nutrition.energyKcal} kcal, fat: {nutrition.fatTotal}g, carbs: {nutrition.carb}g, protein: {nutrition.protein}g,
      salt: {nutrition.salt}g
    </span>
  );
};
